import React from 'react';
import { Filter } from 'lucide-react';

interface FiltersProps {
  mainFilter: string;
  region: string;
  ageRange: string;
  gender: string;
  onMainFilterChange: (filter: string) => void;
  onRegionChange: (region: string) => void;
  onAgeRangeChange: (range: string) => void;
  onGenderChange: (gender: string) => void;
  onClearFilters: () => void;
}

export function Filters({
  mainFilter,
  region,
  ageRange,
  gender,
  onMainFilterChange,
  onRegionChange,
  onAgeRangeChange,
  onGenderChange,
  onClearFilters
}: FiltersProps) {
  return (
    <div className="bg-white rounded-lg shadow-sm p-4 mb-6">
      <div className="flex items-center justify-between mb-4">
        <div className="flex items-center">
          <Filter className="w-5 h-5 text-gray-500 mr-2" />
          <h3 className="text-sm font-medium text-gray-700">Filter Requests</h3>
        </div>
        {(mainFilter !== 'all' || region || ageRange || gender) && (
          <button
            onClick={onClearFilters}
            className="text-sm text-gray-500 hover:text-gray-700"
          >
            Clear All
          </button>
        )}
      </div>
      
      <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Request Status
          </label>
          <select
            value={mainFilter}
            onChange={(e) => onMainFilterChange(e.target.value)}
            className="w-full p-2 text-sm border rounded-md focus:ring-1 focus:ring-indigo-500"
          >
            <option value="all">All Requests</option>
            <option value="new">New Requests (No Bids)</option>
            <option value="active">Active Bidding</option>
            <option value="expired">Expired</option>
            <option value="won">Won Bids</option>
            <option value="hidden">Hidden Requests</option>
            <option value="no_bids_from_us">No Bids From Us</option>
          </select>
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Region
          </label>
          <select
            value={region}
            onChange={(e) => onRegionChange(e.target.value)}
            className="w-full p-2 text-sm border rounded-md focus:ring-1 focus:ring-indigo-500"
          >
            <option value="">All Regions</option>
            <option value="england">England</option>
            <option value="scotland">Scotland</option>
            <option value="wales">Wales</option>
            <option value="northern_ireland">Northern Ireland</option>
          </select>
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Age Range
          </label>
          <select
            value={ageRange}
            onChange={(e) => onAgeRangeChange(e.target.value)}
            className="w-full p-2 text-sm border rounded-md focus:ring-1 focus:ring-indigo-500"
          >
            <option value="">All Ages</option>
            <option value="17-25">17-25 years</option>
            <option value="26-35">26-35 years</option>
            <option value="36-45">36-45 years</option>
            <option value="46-55">46-55 years</option>
            <option value="56-65">56-65 years</option>
            <option value="66+">66+ years</option>
          </select>
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Gender
          </label>
          <select
            value={gender}
            onChange={(e) => onGenderChange(e.target.value)}
            className="w-full p-2 text-sm border rounded-md focus:ring-1 focus:ring-indigo-500"
          >
            <option value="">All Genders</option>
            <option value="male">Male</option>
            <option value="female">Female</option>
            <option value="other">Other</option>
          </select>
        </div>
      </div>
    </div>
  );
}